/* eslint-disable no-console */
/* eslint-disable import/prefer-default-export */
import { useMemo, useState, useEffect, useCallback } from 'react'

export function useMedia(queries, values, defaultValue) {
  const [value, setValue] = useState(defaultValue)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  const mediaQueryLists = useMemo(() => {
    if (!isClient) return []
    return queries.map((q) => window.matchMedia(q))
  }, [queries, isClient])

  const getValue = useCallback(() => {
    if (!isClient) return defaultValue
    const index = mediaQueryLists.findIndex((mql) => mql.matches)
    return values[index] !== undefined ? values[index] : defaultValue
  }, [defaultValue, mediaQueryLists, values, isClient])

  useEffect(() => {
    if (!isClient) return

    setValue(getValue())

    const handler = () => setValue(getValue())
    mediaQueryLists.forEach((mql) => mql.addEventListener('change', handler))

    return () => {
      mediaQueryLists.forEach((mql) => mql.removeEventListener('change', handler))
    }
  }, [getValue, mediaQueryLists, isClient])

  if (typeof window === 'undefined') return defaultValue
  if (queries.length !== values.length) {
    console.error('useMedia: queries and values length mismatch')
    return defaultValue
  }

  return value
}
